import NotificationRequestCard from './NotificationRequestCard';

export default NotificationRequestCard;
